import { useTranslation } from 'react-i18next'

const useTranslatedOrOriginalText = (resources = 'common') => {
  const { t } = useTranslation(resources)

  const getTranslatedOrOriginalText = (key, originalValue) => {
    const translation = t(key + originalValue)
    return translation === key + originalValue ? originalValue : translation
  }

  return { getTranslatedOrOriginalText }
}

export default useTranslatedOrOriginalText
